import { directStatus, userClassification, napStatus } from "@/data/constances";

export default {
  computed: {
    classification() {
      return function(classification) {
        return userClassification.find((item) => item.value == classification);
      };
    },
    chipText() {
      return function(classification) {
        return userClassification.find((item) => item.value == classification)
          ?.text;
      };
    },
    chipColor() {
      return function(classification) {
        return userClassification.find((item) => item.value == classification)
          ?.color;
      };
    },

    getBackgroundCard() {
      return function(status) {
        switch (status) {
          case directStatus.PENDING:
            return "#FAFEFF";
          case directStatus.APPROVED:
            return "#FDFFFA";
          case directStatus.REJECT:
          case directStatus.DELETED:
            return "#FFFBFB";
          default:
            return "#FFFBFB";
        }
      };
    },
    getBtnLightColor() {
      return function(status) {
        switch (status) {
          case directStatus.PENDING:
            return "blue";
          case directStatus.APPROVED:
            return "lightGreen";
          case directStatus.DELETED:
          case directStatus.REJECT:
            return "lightRed";
        }
      };
    },
    getBtnColor() {
      return function(status) {
        switch (status) {
          case directStatus.PENDING:
            return "primary";
          case directStatus.APPROVED:
            return "green";
          case directStatus.DELETED:
          case directStatus.REJECT:
            return "green";
          default:
            return "primary";
        }
      };
    },
    getBtnText() {
      return function(status) {
        switch (status) {
          case directStatus.PENDING:
            return "신청서 보기";
          case directStatus.APPROVED:
            return "자문서 보기";
          case directStatus.REJECT:
          case directStatus.DELETED:
            return "자문서 보기";
          default:
            return "신청서 보기";
        }
      };
    },
    getBadgeVariant() {
      return function(status) {
        switch (status) {
          case directStatus.PENDING:
            return "green";
          case directStatus.APPROVED:
            return "blue";
          case directStatus.REJECT:
            return "red";
          case directStatus.DELETED:
            return "gray";
          default:
            return "red";
        }
      };
    },
    getBtnLabel() {
      return function(status) {
        switch (status) {
          case directStatus.PENDING:
            return "승인 대기";
          case directStatus.APPROVED:
            return "승인 완료";
          case directStatus.REJECT:
            return "승인 거절";
          case directStatus.DELETED:
            return "승인 삭제";
          default:
            return "승인 대기";
        }
      };
    },
    getBtnLabelNapAdmin() {
      return function(status) {
        switch (status) {
          case napStatus.PENDING:
            return "승인 대기";
          case napStatus.APPROVED:
            return "승인 완료";
          case napStatus.REJECT:
            return "승인 거절";
          case napStatus.DELETED:
            return "승인 삭제";
          default:
            return "승인 대기";
        }
      };
    },
    getNapStatus() {
      return function(status) {
        var obj = {};
        switch (status) {
          case napStatus.PENDING:
            return (obj = {
              btnColor: "green",
              btnText: "자문서 작성",
            });
          case napStatus.APPROVED:
            return (obj = {
              btnColor: "gray",
              btnText: "자문서 보기",
            });
          default:
            return obj;
        }
      };
    },
    getMatChingNapStatus() {
      return function(status) {
        var obj = {};
        switch (status) {
          case napStatus.PENDING:
            return (obj = {
              chipText: "자문 대기",
              chipColor: "green",
              btnColor: "blue",
              bgColor: "#FAFEFF",
            });
          case napStatus.APPROVED:
            return (obj = {
              chipText: "자문 완료",
              chipColor: "blue",
              btnColor: "green",
              bgColor: "#FDFFFA",
            });
          case directStatus.REJECT:
            return {
              chipText: "승인 거절",
              chipColor: "red",
              btnColor: "blue",
              bgColor: "#FDFFFA",
            };
          default:
            return obj;
        }
      };
    },
  },
  methods: {},
};
